import axios from 'axios';
import { API_PORT, DEPLOYENVIRONMENT, FILE_PORT } from 'apiConfig';

const apiAxios = axios.create({
	// baseURL: `https://${DEPLOYENVIRONMENT}lynorg.com:5443`,
	baseURL: `https://${DEPLOYENVIRONMENT}api.lynorg.com:${API_PORT}`,
});

const fileAxios = axios.create({
	// baseURL: `https://${DEPLOYENVIRONMENT}lynorg.com:16443/lynorg-service/endpoint/filemngt`,
	baseURL: `https://${DEPLOYENVIRONMENT}file.lynorg.com:${FILE_PORT}`,
});

export { apiAxios, fileAxios };
